import { lazy } from "react";

export const LazyUserProfilePage = lazy(async () => ({
    default: (await import("./UserProfilePage")).UserProfilePage
}));

export const LazyNoFirmPage = lazy(async () => ({
    default: (await import("./NoFirmPage")).NoFirmPage
}));
